<img class="logo" src="logo/{{ variant() }}-{{ theme() }}.svg" alt="" />
@if (theme() === 'light') {
  <img class="logo-on-dark-theme" src="logo/{{ variant() }}-dark.svg" alt="" />
}
